import Vue from 'vue'

var showMsg = function (msg, result) {
  if (result === undefined || result === false) {
    this.$toasted.show('<span class="ion ion-ios-information-circle-outline" style="padding-right:10px;"></span>' + msg, { theme: 'toasted-primary', position: 'bottom-center', className: 'bg-danger', duration: 4000 })
  } else {
    this.$toasted.show('<span class="ion ion-md-checkmark" style="padding-right:10px;"></span>' + msg, { theme: 'toasted-primary', position: 'bottom-center', className: 'bg-success', duration: 4000 })
  }
}
var showNocation = function (msg) {
  this.$notify({ group: 'notifications-bottom-center', text: '<span class="ion ion-ios-information-circle-outline" style="padding-right:10px;"></span>' + msg })
}
Vue.prototype.$showMsg = showMsg
Vue.prototype.$showNocation = showNocation
export default {
  showMsg: showMsg,
  showNocation: showNocation
}
